import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';

import './SaveDialog.scss';

class SaveDialog extends Component {
  render() {
    const modalCloseButton = <div className="close-modal" onClick={this.props.toggle}></div>    
    return (
      <div className="save-dialog">
        <Modal isOpen={this.props.visible} toggle={this.props.toggle} centered={true} className="save-dialog-modal"  modalClassName="save-dialog">
          {modalCloseButton}
          <ModalBody>
            <h2>Do you want to save your {this.props.name}</h2>  
            <p>You are still editing your <b>{this.props.name}</b>. Do you want to save changes before continuing?</p>          
            <div className="button-container">
              <Button onClick={this.props.onClickSave} color="primary">Save</Button><Button onClick={this.props.onClickCancel}>Cancel</Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

SaveDialog.defaultProps= {  
  name: "",
  visible: false,
  onClickSave:() => {},
  onClickCancel:() => {}
};

SaveDialog.propTypes = {
  name: PropTypes.string,
  visible: PropTypes.bool,
  onClickSave: PropTypes.func,
  onClickCancel: PropTypes.func
};

export default SaveDialog;


// WEBPACK FOOTER //
// ./src/components/SaveDialog/SaveDialog.js